/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Show_On_WebInputs */

const vi_shop_show_on_web = /** @type {(inputs: Shop_Show_On_WebInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiện trên web`)
};

/**

* @param {Shop_Show_On_WebInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_show_on_web = /** @type {((inputs?: Shop_Show_On_WebInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Show_On_WebInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_show_on_web(inputs)
});